module.exports = __webpack_public_path__ + "static/aboutus-3-min-ceac1992e0553a4f6be9fa530d7adadc.png";